import request from '@/utils/request'
const BASE_URL = '/pdd/printlog'

export default {
  getLogs(params, mallId = null) {
    // if (token) request.defaults.headers['Authorization'] = "Bearer " + token;
    var headers = { 'UnCheck': 'uncheck' };
    if (mallId) headers['mallid'] = mallId;
    return request({
      url: BASE_URL,
      method: 'get',
      params,
      headers: headers
    })
  },
}